import { ReactComponent as Play } from "../assets/play-circle-outline.svg";
import { ReactComponent as Trash } from "../assets/trash-2-outline.svg";

export default function PollList({ children: polls, onStart, onDelete }) {
    const renderPoll = (poll) => {
        return <li key={poll} className="flex py-3 space-x-1 items-center text-gray-800 border-b last:border-b-0">
            <b className="flex-1 mr-3">{poll.question}</b>

            <Play
                className="w-6 h-6 flex-shrink-0 cursor-pointer transition-colors hover:text-primary"
                onClick={() => onStart(poll.type, poll.question, poll.answers)} />

            <Trash
                className="w-6 h-6 flex-shrink-0 cursor-pointer transition-colors hover:text-primary"
                onClick={() => onDelete(poll.id)} />
        </li>;
    }

    return (
        <ul className="list-unstyled">
            {polls.map(renderPoll)}
        </ul>
    );
}
